import script from "./MultipleSessionsDetectedPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./MultipleSessionsDetectedPopup.vue?vue&type=script&setup=true&lang=ts"

import "./MultipleSessionsDetectedPopup.vue?vue&type=style&index=0&id=b4ee43c6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b4ee43c6"]])

export default __exports__